import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf90f40e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-8" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle icon" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-center mb-6" }, "Pedido gerado com sucesso!", -1))
const _hoisted_4 = { class: "fs-5 text-center" }
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" para baixar o boleto. ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-6 text-center" }, " Atenção, a liberação do conteúdo só será feita após a confirmação do pagamento que pode levar até 3 dias úteis. Você receberá um e-mail assim que o pagamento for confirmado e o conteúdo liberado. ", -1))

import {useStore} from "vuex";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("p", _hoisted_4, [
      _createElementVNode("a", {
        href: _unref(store).getters.getBoletoUrl,
        target: "_blank"
      }, "CLIQUE AQUI", 8, _hoisted_5),
      _hoisted_6
    ]),
    _hoisted_7
  ]))
}
}

})